document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('ContactForm');
  
  form.addEventListener('submit', function(e) {
    e.preventDefault(); // Prevent the default form submission
    var formData = new FormData(form); // Create a FormData object
    fetch(form.action, {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error('Network response was not ok.');
      }
    })
    .then(data => {
      // Handle success
      console.log(data);
      if(data.status){
       console.log(data);
           var element = document.getElementById("success-msg");
          element.classList.remove("hidden");
        document.body.scrollTop = document.documentElement.scrollTop = 0;

       //alert('Form submitted successfully!');
      }
      else{
       alert('Error: '+ data.message);
      }
      document.getElementById("ContactForm").reset();

      //window.location.reload();
    })
    .catch(error => {
      // Handle error
      console.log(error.message)
      alert('Form submission failed: ' + error.message);
    });
  });
});